export type DeficitLabel = {
  text: string;
  colour: string;
};

const GREEN  = '#007c86';
const AMBER  = '#e8a030';
const GREY   = '#888888';

export function interpretDeficit(signedDeficit: number): DeficitLabel {
  if (signedDeficit < -200) return { text: 'Surplus',                colour: AMBER };
  if (signedDeficit <=   0) return { text: 'Maintenance',            colour: GREY  };
  if (signedDeficit <= 300) return { text: 'Low deficit',            colour: GREY  };
  if (signedDeficit <= 600) return { text: 'Steady deficit',         colour: GREEN };
  if (signedDeficit <= 900) return { text: 'High deficit',           colour: GREEN };
  if (signedDeficit <= 1200) return { text: 'Very large deficit',    colour: GREEN };
  return                          { text: 'Extremely large deficit', colour: AMBER };
}
